<template>
    <div>
        <div>
            <div class="smart-main-search-container flex flex-wrap">
                <!--<div class="w-180 mr-10">-->
                <!--<el-input v-model="searchParams.userName" placeholder="请输入用户名"></el-input>-->
                <!--</div>-->
                <!--<div class="w-180 mr-10">-->
                <!--<el-input v-model="searchParams.userNo" placeholder="请输入用户编号"></el-input>-->
                <!--</div>-->
                <!--<div class="w-180 mr-10">-->
                <!--<el-input v-model="searchParams.tel" placeholder="请输入用户电话"></el-input>-->
                <!--</div>-->
                <div class="w-180 mr-10">
                    <el-input v-model="searchParams.meterNo" placeholder="请输入电表号"></el-input>
                </div>
                <div class="w-180 mr-10">
                    <el-input v-model="searchParams.conNo" placeholder="请输入集中器号"></el-input>
                </div>


                <div class="w-180 mr-10">
                    <dropdown placeholder="请选择监控结果" v-model="searchParams.status"
                              :data-list="globalData.taskStatusList"></dropdown>
                </div>


                <div class="w-180 mr-10">
                    <date-picker v-model="searchParams.startDateStr" value-format="yyyy-MM-dd"
                                 placeholder="请选择开始时间"></date-picker>
                </div>
                <div class="w-180 mr-10">
                    <date-picker v-model="searchParams.endDateStr" value-format="yyyy-MM-dd"
                                 placeholder="请选择结束时间"></date-picker>
                </div>
                <div class="flex-1"></div>
                <div class="flex">
                    <load-button class="mr-10" @on-click="search"></load-button>
                    <el-button type="primary" @click="add" plain>新增监控</el-button>
                    <el-button type="primary" @click="add2" plain>自组帧命令</el-button>
                    <el-button type="primary" @click="set" plain>定时监控设置</el-button>
                    <el-button type="primary" @click="exportE" plain>导出数据</el-button>
                    <el-button type="primary" @click="toChart" plain>数据报表</el-button>
                </div>
            </div>
        </div>
        <div class="content mt-20">
            <smart-table :table-label="labels" :table-data="searchData.list" :table-opt="opt"></smart-table>
        </div>

        <div class="flex flex-right mt-20">
            <pagination :page="searchParams.page" :pages="searchData" @on-search="toPage"></pagination>
        </div>

        <form-dialog ref="model" title="新增监控" @on-confirm="save">
            <div slot="dialog-main">
                <el-form>
                    <div class="flex flex-mid">

                        <div class="flex-1">
                            <el-form-item :key="detail.id" label="集中号" label-width="120px">
                                <dropdown placeholder="请选择集中器" v-model="temp.conId"
                                          data-url="/smartMeter/concentrator/all" value-key="id"
                                          show-key="dtuNo"></dropdown>
                            </el-form-item>
                            <el-form-item label="表号" label-width="120px">
                                <dropdown placeholder="请选择表号" v-model="temp.meterNo"
                                          :data-url="'/smartMeter/user/conMeter?conId='+temp.conId" value-key="meterNo"
                                          show-key="meterNo"></dropdown>
                                <el-checkbox-group
                                        v-model="protocolSelected"
                                >
                                    <el-checkbox v-for="meterProtocol in meterProtocols" :label="meterProtocol.dataCode"
                                                 :key="meterProtocol.dataCode">{{meterProtocol.name}}
                                    </el-checkbox>
                                </el-checkbox-group>

                            </el-form-item>
                        </div>
                    </div>
                </el-form>
            </div>
        </form-dialog>

        <form-dialog ref="model2" title="新增命令帧" @on-confirm="save2">
            <div slot="dialog-main">
                <el-form>
                    <div class="flex flex-mid">

                        <div class="flex-1">
                            <el-form-item :key="detail.id" label="集中号" label-width="120px">
                                <dropdown placeholder="请选择集中器" v-model="temp2.conId"
                                          data-url="/smartMeter/concentrator/all" value-key="id"
                                          show-key="dtuNo"></dropdown>
                            </el-form-item>
                            <el-form-item label="指令帧" label-width="120px">
                                <el-input v-model="temp2.sendMsg"></el-input>
                            </el-form-item>
                        </div>
                    </div>
                </el-form>
            </div>
        </form-dialog>



        <form-dialog ref="modelDetail" title="监控详情" @on-confirm="save" :show-confirm="showConfirm"
                     :show-close="showClose">
            <div slot="dialog-main">
                <el-form>
                    <el-form-item :key="detail.id" label="表号" label-width="250px">
                        <span class="ml-20 " style="color: #333">{{detail.meterNo}}</span>
                    </el-form-item>
                    <el-form-item v-for="item in  detail.exeTaskLists" :key="item.id" :label="item.name"
                                  label-width="250px">
                        <span class="ml-20 " style="color: #333">{{getValue(item)}}</span>
                    </el-form-item>
                </el-form>

            </div>
        </form-dialog>


        <form-dialog ref="modelSetting" title="定时监控设置" @on-confirm="saveSetting">
            <div slot="dialog-main">
                <el-form>
                    <div class="flex flex-mid">
                        <div class="flex-1">
                            <el-form-item label="是否启用" label-width="120px">
                                <el-checkbox label="" v-model="companyMonitor.isOpen"></el-checkbox>
                            </el-form-item>
                        </div>
                    </div>
                    <div v-if="companyMonitor.isOpen" class="flex flex-mid">
                        <div class="flex-1">
                            <el-form-item label="监控类型" label-width="120px">
                                <dropdown placeholder="请选择监控类型" v-model="companyMonitor.type"
                                          :data-list="globalData.companyMonitorType"></dropdown>
                            </el-form-item>
                            <el-form-item v-if="companyMonitor.type  == 1" label="固定时间(每天)" label-width="120px">

                                <el-time-picker v-model="companyMonitor.monitorTime" value-format="HH:mm:ss"
                                                :picker-options="{}"
                                                placeholder="请选择开始时间">
                                </el-time-picker>
                            </el-form-item>
                            <el-form-item v-if="companyMonitor.type  == 2" label="时间间隔(分钟)" label-width="120px">
                                <el-input v-model="companyMonitor.monitorInterval"></el-input>
                            </el-form-item>
                        </div>

                    </div>
                    <div v-if="companyMonitor.isOpen" class="flex flex-mid">
                        <div class="flex-1">
                            <el-form-item label="监控内容" label-width="120px">
                                <el-checkbox-group v-model="protocolSelected">
                                    <div class="flex-1 ">
                                        <div class="set-blk flex flex-mid" v-for="meterProtocol in meterProtocols">
                                            <div  style="width: 270px">
                                                <el-checkbox :label="meterProtocol.id"
                                                             :key="meterProtocol.id">{{meterProtocol.name}}
                                                </el-checkbox>

                                            </div>
                                            <div style="font:initial;width: 80px;"  class="mt-5">监控值：</div>


                                            <div class="w60 ml-10">
                                                <dropdown placeholder=" " show-key="name" value-key="id"  v-model="meterProtocol.alarmType" :data-list="{1:'<',2:'>'}"></dropdown>
                                            </div>
                                            <div class="ml-10 " style="width: 100px">
                                                <el-input  type="number" v-model="meterProtocol.alarmThreshold"></el-input>
                                            </div>
                                        </div>
                                    </div>
                                </el-checkbox-group>
                            </el-form-item>
                        </div>
                    </div>
                </el-form>
            </div>
        </form-dialog>

        <form-dialog ref="chartModel" title="数据图标"  @on-confirm="save" :show-confirm="showConfirm"
                     :show-close="showClose">
            <div slot="dialog-main">

                <div class="flex flex-top mt-10">
                    <div class="mt-5 w60">图表类型</div>
                    <div class="flex-1 flex flex-wrap">
                        <customer-radio class="mr-10 mb-10" v-model="chartConfig.type" :radio-data="{id:1,name:'折线'}"></customer-radio>
                        <!--                        <customer-radio class="mr-10 mb-10" v-model="chartConfig.type" :radio-data="{id:2,name:'柱状'}"></customer-radio>-->
                    </div>
                </div>
                <div class="flex flex-top">
                    <div class="mt-5 w60">表号</div>
                    <div class="w-380">
                        <!--<el-input v-model="chartConfig.meterNo"></el-input>-->
                        <dropdown placeholder=" " show-key="name" value-key="id"  v-model="chartConfig.userId" data-url="/smartMeter/user/companyUsers"></dropdown>
                    </div>
                </div>
                <div class="flex flex-top mt-10">
                    <div class="mt-5 w60">监控类型</div>
                    <div class="w-380">
                        <!--<el-input v-model="chartConfig.meterNo"></el-input>-->
                        <dropdown placeholder="选择类型" show-key="name" value-key="id"  v-model="chartConfig.meterProtocolId" :data-list="protocolObjectSelected"></dropdown>
                    </div>
                    <!--<div v-for="meterProtocol in protocolObjectSelected" class="flex-1 flex flex-wrap">-->
                        <!--<customer-radio class="mr-10 mb-10" v-model="chartConfig.companyMonitorProtocolId" :radio-data="meterProtocol"></customer-radio>-->
                    <!--</div>-->
                </div>
                <div class="flex flex-mid mt-10">
                    <div class="mt-5 w60">时间</div>
                    <div class="flex  flex-mid flex-wrap">
                        <div class="w-180 mr-10">
                            <date-picker v-model="chartConfig.startDate" value-format="yyyy-MM-dd"
                                         placeholder="请选择开始时间"></date-picker>
                        </div>
                        -
                        <div class="w-180 mr-10">
                            <date-picker v-model="chartConfig.endDate" value-format="yyyy-MM-dd"
                                         placeholder="请选择结束时间"></date-picker>
                        </div>
                    </div>
                </div>




                <div class="mt-10">
                    <el-button type="primary" @click="drawChart" plain>生成报表</el-button>
                </div>
                <div id="chart" class="chart">

                </div>
            </div>
        </form-dialog>

    </div>
</template>
<script>
    import LoadButton from "../../components/LoadButton";
    import Pagination from "../../components/Pagination";
    import SmartTable from "../../components/SmartTable";
    import FormDialog from "../../components/FormDialog";
    import UploadImg from "../../components/UploadImg";
    import Dropdown from "../../components/Dropdown";
    import DatePicker from "../../components/DatePicker";
    import CustomerRadio from "../../components/CustomerRadio";
    const showNumber = 10;//显示的数据个数，不包括头尾
    export default {
        components: {
            CustomerRadio,
            DatePicker,
            Dropdown,
            UploadImg,
            FormDialog,
            SmartTable,
            Pagination,
            LoadButton
        },
        data() {
            return {
                searchParams: {
                    page: 1
                },
                searchData: {},
                opt: [
                    {label: '详情', fn: this.toDetail}
                ],
                labels: [

                    {prop: 'userName', label: '用户名'},
                    {prop: 'meterNo', label: '表号'},

                    {prop: 'conNo', label: '集中器号'},
                    {prop: 'userAddr', label: '用户地址'},

                    {prop: 'createAt', label: '抄收时间'},
                    // {prop: 'MonitorType', label: '监控类型', map: this.globalData.MonitorType},
                    {prop: 'status', label: '状态', map: this.globalData.taskStatusList},

                ],
                temp: {},
                temp2: {},
                meterProtocols: [],
                protocolSelected: [],
                protocolObjectSelected:[],
                showConfirm: false,
                showClose: false,
                detail: {},
                companyMonitor: {},
                chartConfig:{}

            }
        },
        mounted() {
            this.getList();
            this.$http$({
                    method: "get",
                    url: "/smartMeter/MonitorDataTab/setting",
                }, (data) => {
                    console.log(data);
                    this.meterProtocols = data || [];
                }
            );

        },
        methods: {
            search(stop) {
                this.searchParams.page = 1
                this.getList(stop)
            },
            toPage(page) {
                this.searchParams.page = page
                this.getList()
            },
            getList(callback) {
                if (this.$store.state.LoginUser.gardenId) {
                    this.searchParams.gardenID = this.$store.state.LoginUser.gardenId
                }
                this.$http$({
                    method: 'get',
                    url: "/smartMeter/MonitorDataTab",
                    data: this.searchParams,
                    load: 1
                }, (data) => {
                    callback ? callback() : ''
                    this.searchData = data
                })
            },
            toDetail(item) {
                this.$http$({
                        method: "get",
                        url: "/smartMeter/MonitorDataTab/" + item.id,
                    }, (data) => {

                        this.detail = data;
                        // this.exeTaskLists = data.exeTaskLists;
                        // this.centerDialogVisible = true;
                        this.$refs.modelDetail.show();
                    }
                );


            },
            saveSetting() {
                // console.log(this.protocolSelected);
                var companyMonitorProtocols = [];
                var selectedMap = {};
                for (var i in this.protocolSelected) {
                    if(selectedMap[this.protocolSelected[i]]){
                        continue;
                    }
                    for (var j in this.meterProtocols){
                        var meterProtocol = this.meterProtocols[j];
                        if(meterProtocol.id == this.protocolSelected[i]){
                            selectedMap[this.protocolSelected[i]] = true;
                            var companyMonitorProtocol = {};
                            companyMonitorProtocol.meterProtocolId = this.protocolSelected[i];
                            companyMonitorProtocol.alarmThreshold = meterProtocol.alarmThreshold;
                            companyMonitorProtocol.alarmType = meterProtocol.alarmType;
                            companyMonitorProtocols.push(companyMonitorProtocol);
                            break;
                        }
                    }



                }
                this.companyMonitor.companyMonitorProtocol = companyMonitorProtocols;
                if (this.companyMonitor.isOpen) {
                    this.companyMonitor.status = 1;
                } else {
                    this.companyMonitor.status = 9;
                }

                let method = 'put', url = "/smartMeter/CompanyMonitoring", msg = '设置成功！'
                this.$http$({method: method, url: url, data: this.companyMonitor}, (data) => {
                    this.$success(msg)
                    this.getList();
                    //this.$refs.model.close()
                })


            },
            set() {
                this.protocolSelected = [];
                // this.companyMonitor = {isOpen:true}
                // this.$refs.modelSetting.show();
                // return;
                this.$http$({
                        method: "get",
                        url: "/smartMeter/CompanyMonitoring",
                    }, (data) => {
                        if (!data) {
                            return;
                        }
                        data.isOpen = data.status == 1;
                        for (var i in data.companyMonitorProtocol) {
                            var companyMonitorProtocol = data.companyMonitorProtocol[i];
                            this.protocolSelected.push(companyMonitorProtocol.meterProtocolId)
                            for (var j in this.meterProtocols){
                                var meterProtocol = this.meterProtocols[j];
                                if(meterProtocol.id == companyMonitorProtocol.meterProtocolId){
                                    meterProtocol.alarmThreshold = companyMonitorProtocol.alarmThreshold;
                                    meterProtocol.alarmType = companyMonitorProtocol.alarmType;
                                }

                            }

                        }
                        this.companyMonitor = data;
                        // this.exeTaskLists = data.exeTaskLists;
                        // this.centerDialogVisible = true;
                        this.$refs.modelSetting.show();
                    }
                );
            },
            add() {
                this.temp = {conId:""}
                this.protocolSelected = [];
                this.$refs.model.show()
            },
            add2() {
                this.temp2 = {conId:""}
                this.$refs.model2.show()
            },
            save2() {
                let method = 'post', url = "/smartMeter/MonitorDataTab/order", msg = '新增成功！'
                // if (this.myData.id) {
                //   method = 'put'
                //   msg = '修改信息成功！'
                // }
                this.$http$({method: method, url: url, data: this.temp2}, (data) => {
                    this.$success(msg)
                    this.getList();
                    //this.$refs.model.close()
                })
            },
            save() {
                console.log(this.protocolSelected);
                var exeTaskLists = [];
                for (var i in this.protocolSelected) {
                    // if(this.protocolSelected[i]){

                    exeTaskLists.push({dataCode: this.protocolSelected[i]})
                    // }

                }

                this.temp.exeTaskLists = exeTaskLists;
                let method = 'post', url = "/smartMeter/MonitorDataTab", msg = '新增成功！'
                // if (this.myData.id) {
                //   method = 'put'
                //   msg = '修改信息成功！'
                // }
                this.$http$({method: method, url: url, data: this.temp}, (data) => {
                    this.$success(msg)
                    this.getList();
                    //this.$refs.model.close()
                })

            },
            exportE(){
                let url =  this.globalData.host+ "/smartMeter/export/MonitorDataTab?accessToken="+this.$store.state.LoginUser.accessToken||"";
                // var isFirst = true;
                for (var i in this.searchParams){
                    url += "&";
                    url+= encodeURIComponent(i) +"=" +encodeURIComponent(this.searchParams[i]);
                }
                this.$http$({method: 'get', url: url}, () => {
                    this.$router.push('/admin/downLoadTask')

                })
            },
            getValue(item) {
                if (item.status == 1) {
                    return "待处理";
                } else if (item.status == 2) {
                    return '处理中';
                } else if (item.status == 3) {
                    if(item.type == 5){
                        return item.backMsg;
                    }else{
                        return item.value;
                    }

                } else if (item.status == 4) {
                    return "失败";
                }
            },
            toChart(){
                this.chartConfig = {type:1}
                this.$http$({
                        method: "get",
                        url: "/smartMeter/CompanyMonitoring",
                    }, (data) => {
                        if (!data) {
                            return;
                        }
                        for (var j in this.meterProtocols){
                             var meterProtocol = this.meterProtocols[j];
                            for (var i in data.companyMonitorProtocol) {
                                var companyMonitorProtocol = data.companyMonitorProtocol[i];
                                if(meterProtocol.id == companyMonitorProtocol.meterProtocolId){

                                    this.protocolObjectSelected.push(meterProtocol);
                                    break;
                                }

                            }
                        }

                        this.$refs.chartModel.show()
                    }
                );

            },
            drawChart(){
                const config = this.chartConfig;
                console.log(config);
                debugger;
                this.$http$({method: 'get', url: '/smartMeter/exeTask/'+config.meterProtocolId, data: config}, (data) => {
                    if(!data || data.length == 0){
                        this.$success("没有找到数据");
                        return;
                    }
                    const echarts = require('echarts')

                    let myChart = echarts.init(document.getElementById('chart'));

                    var xDate = [];
                    var yData = [];
                    var firstV = 0,lastV = 0
                    for (var i in data){
                        if(i == 0){
                            firstV = data[i].firstValue || 0
                        }
                        if(i == data.length - 1){
                            lastV = data[i].firstValue || 0
                        }
                        xDate.push(new Date(data[i].updateAt).pattern('yyyy-MM-dd HH:mm'))
                        yData.push(data[i].firstValue)
                    }
                    const sep = parseInt(yData.length/showNumber)

                    if(config.type == 1){
                        let option = {
                            title:{
                                text:'差值：'+(lastV - firstV).toFixed(3),
                            },
                            tooltip: {
                                trigger: 'axis',
                                position: function (pt) {
                                    return [pt[0], '10%'];
                                }
                            },
                            toolbox: {
                                feature: {
                                    dataZoom: {
                                        yAxisIndex: 'none'
                                    },
                                    restore: {},
                                    saveAsImage: {}
                                }
                            },
                            xAxis: {
                                type: 'category',
                                boundaryGap: false,
                                data: xDate
                            },
                            yAxis: {
                                type: 'value',
                                boundaryGap: [0, '100%']
                            },
                            dataZoom: [{
                                startValue: '0'
                            }, {
                                type: 'inside'
                            }],
                            series: [
                                {
                                    name:'数据',
                                    type:'line',
                                    smooth:true,
                                    // symbol: 'none',
                                    sampling: 'average',
                                    itemStyle: {
                                        color: 'rgb(255, 70, 131)'
                                    },
                                    label: {
                                        show: true,
                                        position: 'top',
                                        offset:[0,-10],
                                        formatter:(a,b,c) => {
                                            if((a.dataIndex == 0)||(a.dataIndex == yData.length - 1)){
                                                return a.data;
                                            }else if(a.dataIndex%sep ==0){
                                                return a.data;
                                            }
                                            return ''
                                        }
                                        // color:'#333'
                                    },
                                    areaStyle: {
                                        color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                            offset: 0,
                                            color: 'rgb(255, 158, 68)'
                                        }, {
                                            offset: 1,
                                            color: 'rgb(255, 70, 131)'
                                        }])
                                    },
                                    data: yData
                                }
                            ]
                        };
                        myChart.setOption(option);
                    }else{

                    }
                })


            }

        }
    }
</script>
<style scoped>
    .mt-5{
        margin-top: 5px;
    }
    .set-blk{
        /*min-width: 240px;*/
    }
    .w60{
        width: 60px;
    }
    .chart{
        width: calc(100%);
        height: 400px;
        margin-top: 20px;
        background: #f9f9f9;
    }
</style>



// WEBPACK FOOTER //
// src/pages/admin/Task.vue